import getPointFromCursor from './getPointFromCursor';
import findCursors from './findCursors';
export default function restoreSelection(editor, selection, textsSnapshot) {
  var _findCursors = findCursors(editor),
      anchorCursor = _findCursors.anchorCursor,
      focusCursor = _findCursors.focusCursor;

  var anchor = getPointFromCursor(editor, textsSnapshot, anchorCursor);
  var focus = getPointFromCursor(editor, textsSnapshot, focusCursor); // We keep selection direction

  if (selection.isForward && anchor.isAfterPoint(focus)) {
    anchor = focus;
  } else if (selection.isBackward && focus.isAfterPoint(anchor)) {
    focus = anchor;
  }

  return {
    anchor: anchor,
    focus: focus
  };
}